import axios, { AxiosResponse } from 'axios';
import { TESTING_HEADERS } from 'src/backoffice-app-code/configs/appConfig';
import { PartnerId } from '../../models/PartnerModel';
import { DistributorDTO } from '../DTOs/DistributorDTO';
import { NewDistributorDTO } from '../DTOs/NewDistributorDTO';
import { NewRetailerDTO } from '../DTOs/NewRetailerDTO';
import { RetailerDTO } from '../DTOs/RetailerDTO';
import { UpdateDistributorDTO } from '../DTOs/UpdateDistributorDTO';
import { UpdateRetailerDTO } from '../DTOs/UpdateRetailerDTO';

const baseUrl = `${process.env.REACT_APP_LOYALTY_API}/partner`;

const CreateRetailerAsync = async (retailer: NewRetailerDTO): Promise<string> => {
  const response = await axios.post(`${baseUrl}/CreateRetailer`, retailer, TESTING_HEADERS);
  return response.data;
};

const CreateDistributorAsync = async (distributor: NewDistributorDTO): Promise<string> => {
  const response = await axios.post(`${baseUrl}/CreateDistributor`, distributor, TESTING_HEADERS);
  return response.data;
};

const GetAllRetailersAsync = async (): Promise<RetailerDTO[]> => {
  const response: AxiosResponse<RetailerDTO[]> = await axios.get(`${baseUrl}/GetAllRetailers`, {
    headers: TESTING_HEADERS,
  });
  return response.data;
};

const GetAllDistributorsAsync = async (): Promise<DistributorDTO[]> => {
  const response: AxiosResponse<DistributorDTO[]> = await axios.get(
    `${baseUrl}/GetAllDistributors`,
    {
      headers: TESTING_HEADERS,
    }
  );
  return response.data;
};

const GetAllPartnersAsync = async (): Promise<any[]> => {
  const response: AxiosResponse<any[]> = await axios.get(`${baseUrl}/getAll`, {
    headers: TESTING_HEADERS,
  });
  return response.data;
};

const GetRetailerByIdAsync = async (id: string): Promise<RetailerDTO> => {
  const response: AxiosResponse<RetailerDTO> = await axios.get(
    `${baseUrl}/GetPartnerById?id=${id}`,
    {
      headers: TESTING_HEADERS,
    }
  );
  return response.data;
};

const GetDistributorByIdAsync = async (id: string): Promise<DistributorDTO> => {
  const response: AxiosResponse<DistributorDTO> = await axios.get(
    `${baseUrl}/GetDistributorById?distributorId=${id}`,
    {
      headers: TESTING_HEADERS,
    }
  );
  return response.data;
};

const GetPartnerByIdAsync = async (id: string): Promise<DistributorDTO | RetailerDTO> => {
  const response: AxiosResponse<DistributorDTO | RetailerDTO> = await axios.get(
    `${baseUrl}/GetPartnerById?id=${id}`,
    {
      headers: TESTING_HEADERS,
    }
  );
  return response.data;
};

const PartnerApproveAsync = async (partnerId: PartnerId): Promise<string> => {
  const response = await axios.post(`${baseUrl}/PartnerApprove`, partnerId, TESTING_HEADERS);
  return response.data;
};

const PartnerIncludeAsync = async (partnerId: PartnerId): Promise<string> => {
  const response = await axios.post(`${baseUrl}/PartnerInclude`, partnerId, TESTING_HEADERS);
  return response.data;
};

const PartnerExcludeAsync = async (partnerId: PartnerId): Promise<string> => {
  const response = await axios.post(`${baseUrl}/PartnerExclude`, partnerId, TESTING_HEADERS);
  return response.data;
};

const UpdateRetailerAsync = async (retailer: UpdateRetailerDTO): Promise<string> => {
  const response = await axios.put(`${baseUrl}/UpdateRetailer`, retailer, TESTING_HEADERS);
  return response.data;
};

const UpdateDistributorAsync = async (distributor: UpdateDistributorDTO): Promise<string> => {
  const response = await axios.put(`${baseUrl}/UpdateDistributor`, distributor, TESTING_HEADERS);
  return response.data;
};

const DeleteRetailerImageAsync = async (retailerId: string): Promise<string> => {
  const response = await axios.delete(`${baseUrl}/DeleteRetailerImage?retailerId=${retailerId}`, {
    headers: TESTING_HEADERS,
  });
  return response.data;
};

const DeleteDistributorImageAsync = async (distributorId: string): Promise<string> => {
  const response = await axios.delete(
    `${baseUrl}/DeleteDistributorImage?distributorId=${distributorId}`,
    {
      headers: TESTING_HEADERS,
    }
  );
  return response.data;
};

export const PartnersRepository = {
  GetAllPartnersAsync,
  CreateRetailerAsync,
  CreateDistributorAsync,
  GetAllRetailersAsync,
  GetAllDistributorsAsync,
  GetRetailerByIdAsync,
  GetDistributorByIdAsync,
  GetPartnerByIdAsync,
  PartnerApproveAsync,
  PartnerIncludeAsync,
  PartnerExcludeAsync,
  UpdateRetailerAsync,
  UpdateDistributorAsync,
  DeleteRetailerImageAsync,
  DeleteDistributorImageAsync,
};
